<template>
    <div>
        <CCard class="w-100">
            <CCardBody>
                <CForm>
                    <div class="row CForminline">
                        <div class="search-item col-md-4 col-12">
                            <p>{{ $t('QDFM.QDFMNo') }}：</p>
                            <el-input v-model="search.qdfmNo" maxlength="50"></el-input>
                        </div>

                        <div class="search-item col-md-4 col-12">
                            <p>{{ $t('QDFM.FactoryName') }}：</p>
                            <!-- <el-input v-model="search.customerName" v-if="disableCusName_input" disabled></el-input>
                            <el-select v-model="search.custId" filterable clearable placeholder="" v-if="!disableCusName_input">
                                <template slot="empty">
                                    <p class="el-select-dropdown__empty">無匹配資料</p>
                                </template>
                                <el-option
                                    v-for="item in memberList"
                                    :key="item.vendorId"
                                    :label="`${item.vendorId} - ${item.vendorAbbreviation}`"
                                    :value="item.vendorId"
                                >
                                </el-option>
                            </el-select> -->
                            <input style="width: 286px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="search.customerName">                                                        
                            <Select2 style="width: 260px;" v-if="!disableCusName_input" v-model="search.custId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true}" />
                        </div>

                        <div class="col-md-4 col-12"></div>

                        <div class="search-item col-md-4 col-12">
                            <p>{{ $t('QDFM.MachineName') }}：</p>
                            <el-input v-model="search.machineNo" maxlength="50"></el-input>
                        </div>

                        <div class="search-item col-md-4 col-12">
                            <p>{{ $t('QDFM.ROEPartNumber') }}：</p>
                            <el-input v-model="search.materialNoCust" maxlength="50"></el-input>
                        </div>

                        <div class="search-item col-md-8 col-12">
                            <p>{{ $t('QDFM.StartDate') }}：</p>
                            <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="search.createDateBegin" ></date-picker>
                            <span style="margin: 0 8px;">~</span>
                            <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="search.createDateEnd" ></date-picker> 
                        </div>

                        <div class="search-item col-12">
                            <p>{{ $t('QDFM.FactoryType') }}：</p>
                            <el-radio-group v-model="search.factoryId">
                                <el-radio v-for="(item, key) in factoryList" :key="'factoryType_input_' + key" :label="item.factoryId" :disabled ="disableFactory">{{ getFactoryCaption(item.factoryId,item.factoryCaption) }}</el-radio>
                            </el-radio-group>
                        </div>

                        <div class="search-item col-md-4 col-12">
                            <p>{{ $t('QDFM.AuditResults') }}：</p>
                            <el-select v-model="search.reviewId" placeholder="">
                                <el-option
                                    v-for="item in results"
                                    :key="item.Label"
                                    :label="item.Label"
                                    :value="item.Id"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <div class="btn_group">
                            <button type="button" class="btn btn-edit mr-2" @click.prevent="qdfmQueryEvent">{{ $t('Buttons.Query') }}</button>
                            <button type="button" class="btn btn-success" @click.prevent="doQDFMExport">{{ $t('Buttons.ExportOrder') }}</button>
                        </div> 

                    </div>
                </CForm>
            </CCardBody>
        </CCard>

        <CCard>
            <CCardBody style="overflow: auto;">
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{ headers[0] }}</th>
                            <th class="text-center">{{ headers[1] }}</th>
                            <th class="text-center">{{ headers[2] }}</th>
                            <th class="text-center">{{ headers[3] }}</th>
                            <th class="text-center">{{ headers[4] }}</th>
                            <th class="text-center">{{ headers[5] }}</th>
                            <th class="text-center">{{ headers[6] }}</th>
                            <th class="text-center">{{ headers[7] }}</th>
                            <th class="text-center">{{ headers[8] }}</th>
                            <th class="text-center">{{ headers[9] }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in QDFMSearchResult" :key="index">
                            <td class="text-center">{{ item.factoryId }}</td>
                            <td class="text-center">{{ item.cusAbbreviation }}</td>
                            <td class="text-center">{{ item.machineNo }}</td>
                            <td class="text-center">{{ item.projectName }}</td>                            
                            <td class="text-center">{{ item.materialNoCust }}</td>
                            <td class="text-center">{{ fixDate(item.issueDate) }}</td>
                            <td class="text-center">{{ item.qdfmNo }}</td>
                            <td class="text-center">{{ item.qdfmScore }}</td>
                            <td class="text-center">
                                <span v-if="item.reviewId === 3">{{i18n('QDFM.Manufacturer')}}</span>
                                <span v-if="item.reviewId === 5">{{i18n('QDFM.Quality')}}</span>
                                <span v-if="item.reviewId === 7">{{i18n('QDFM.Reject')}}</span>
                                <span v-if="item.reviewId === 9">{{i18n('QDFM.Close')}}</span>
                            </td>

                            <td class="text-center">
                                <button class="btn btn-sm btn-success mr-2" @click="maintainEvent(item)" data-toggle="modal" data-target="#changeVendorModal" v-if="$userInfo.userType === 'Employee' && (item.reviewId === 3 || item.reviewId === 5 || item.reviewId === 7)">{{$t('Buttons.EditVendor')}}</button>
                                <router-link class="btn btn-sm btn-success mr-2" tag="button" @click.native="detailEvent('reply', item)" to="" v-if="$userInfo.userType === 'Member' && (item.reviewId === 3 ||item.reviewId === 7)">{{ i18n('Buttons.Reply') }}</router-link>
                                <router-link class="btn btn-sm btn-success mr-2" tag="button" @click.native="detailEvent('review', item)" to="" v-if="$userInfo.userType === 'Employee' && item.reviewId === 5">{{ i18n('Buttons.Review') }}</router-link>
                                <router-link class="btn btn-sm btn-info mr-2" tag="button" @click.native="detailEvent('watch', item)" to="">{{ i18n('Buttons.DetailInfo') }}</router-link>
                                <button class="btn btn-sm btn-danger" @click="deleteRowModal(item)" v-if="isQMmanager">{{$t('Buttons.Delete')}}</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>


        <!-- Modal -->
        <div class="modal fade" :id="'changeVendorModal'" tabindex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard ="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        廠商選擇
                    </div>
                    <div class="modal-body">
                        <div class="filter-block">
                            <div class="filter-field">
                                <input type="type" name="name" v-model="filterKeyword" placeholder="關鍵字" />
                            </div>
                            <div class="filter-btn-wrap" @click="doFilterCompany" >
                                <a class="btn btn-02">{{$t('Buttons.Query')}}</a>
                            </div>
                        </div>
                        <div class="item-select">
                            <div id="left-item">                                        
                                <div class="filter-btn-wrap">                                            
                                    <label class="option">                                                
                                        <span>公司</span>
                                    </label>
                                </div>
                                <div class="item-list">
                                    <div class="item_list" v-for="(company) in filterMemberList" :key="'left_' + company.vendorId">
                                        <div class="item employee">                                                    
                                            <input :id="'left_' + company.vendorId " type="radio" :name="'leftSelectCompany'" :value="company" v-model="selectOneLeft" />
                                            <label :for="'left_' + company.vendorId ">{{company.vendorAbbreviation}} [{{company.vendorId}}]</label>
                                        </div>                                                
                                    </div>
                                </div>
                            </div>
                            <div class="center-item">
                                <span class="add-item" @click="addClick"> &gt; </span>
                                <span class="remove-item" @click="removeClick"> &lt; </span>
                            </div>
                            <div id="right-item">
                                <span class="item-type">已選擇</span>
                                <div class="item-list">
                                    <div class="item_list" v-for="(item) in selecteds" :key="'right_' + item.vendorId">
                                        <div class="item">
                                            <input :id="'right_' + item.vendorId " type="radio" :name="'rightSelectCompany'" :value="item" v-model="selectOneRight" />
                                            <label :for="'right_' + item.vendorId ">{{item.vendorAbbreviation}}</label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal" @click="cancel" >{{$t('Buttons.Cancel')}}</button>
                        <button type="button" class="btn btn-blue" data-dismiss="modal" @click.prevent="submitVendor">{{$t('Buttons.SavedData')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {       
            search: {
                reviewId: null,
                factoryId: '',
                qdfmNo: '',
                customerName: '',
                machineNo: '',
                materialNoCust: '',
                createDateBegin :null,
                createDateEnd :null,
            },

            results: this.$t('qdfmStatusList'),     //   審核結果清單
            factoryList: this.$t('factoryQMList'), //廠別 清單
            headers :[
                this.i18n('QDFM.FactoryType'),
                this.i18n('QDFM.FactoryName'),
                this.i18n('QDFM.Machine'),
                this.i18n('QDFM.Project'),
                this.i18n('QDFM.ROEPartNumber'),
                this.i18n('QDFM.StartDate'),
                this.i18n('QDFM.QDFMNo'),
                this.i18n('QDFM.AssessmentScore'),
                this.i18n('QDFM.AuditResults'),
                this.i18n('QDFM.Function'),
            ],
            QDFMSearchResult: [],


            //  修改廠商
            tempRow: null,
            hadVendorList : [],

            selectLeft: [],         //  [左]側已挑選清單
            selectOneLeft: null,    //  [左]側已挑選清單(僅一筆)
            selectRight: [],        //  [右]側已挑選清單            
            selecteds: [],          //  挑選後新增到右側的清單
            selectOneRight: null,   //  [右]側已挑選清單(僅一筆)
            memberList: [],         //  左側清單
            filterKeyword: '',      //  過濾條件
            filterValue: '',
        }
    },
    watch: {
        "lang":function() {
            this.headers = [
                this.i18n('QDFM.FactoryType'),
                this.i18n('QDFM.FactoryName'),
                this.i18n('QDFM.Machine'),
                this.i18n('QDFM.Project'),
                this.i18n('QDFM.ROEPartNumber'),
                this.i18n('QDFM.StartDate'),
                this.i18n('QDFM.QDFMNo'),
                this.i18n('QDFM.AssessmentScore'),
                this.i18n('QDFM.AuditResults'),
                this.i18n('QDFM.Function'),
            ]

            this.factoryList = this.$t('factoryQMList');     //     廠別 清單
            this.results = this.$t('qdfmStatusList');     //     審核結果清單
        }
    },
    methods: {      
        qdfmQueryEvent(){
            this.doQDFMSearch (this.search);         
        },  
        doQDFMSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchQDFMForm`;

            // let param = {
            //     ...this.search,
            // }

            this.updateLoading(true);

            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //  --成功
                    const rows = response.data;

                    this.QDFMSearchResult = rows;
                    this.setCacheQueryParam('QDFM_QueryParam' , param);                           
                }                    
            }); 
        },
        doQDFMExport(){      
            const vm = this;      
            const url = `${this.$apiUrl_Quality}/PrepareSearchQDFMExport`;

            let param = {
                ...vm.search,
            }

            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchQDFMExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('trialExportExcel',urlExcel);
            })
        },

        detailEvent (status, item){     //  詳細資料        
            sessionStorage.setItem('QDFM_Status' , status);
            sessionStorage.setItem('QDFM_Key' , item.qdfmNo);
            
            if(status === 'watch') {
                this.$router.push({ path: '/qdfmformdetail', query: { isWatch: true } });
            } else {
                this.$router.push('qdfmformdetail');
            }

        },


        maintainEvent (item){   //  維護
            if(item){   
                this.hadVendorList.splice(0);
                this.hadVendorList.push({vendorId: item.custId});
                this.tempRow = item;
                return true;
            }else{
                return false;
            }
        },

        doFilterCompany (){     // 過濾查詢，左側清單過濾後的陣列
            this.filterValue = this.filterKeyword;
        },
        addClick() {            
            if(this.selectOneLeft){
                this.selecteds.splice(0);
                this.selectRight.splice(0);
                this.selecteds.push(this.selectOneLeft);
                this.selectRight.push(this.selectOneLeft);
                this.selectOneLeft= null;
            }
        },
        removeClick() {
            if(this.selectOneRight){
                this.selecteds.splice(0);
                this.selectRight.splice(0);
            }
        },
        cancel(){            
            this.selecteds = [];
            this.selectLeft = [];
            this.selectRight = [];
            this.filterValue = '';
            this.filterKeyword= '';
        },
        submitVendor() {
            if(!this.selecteds || this.selecteds.length === 0){
                this.$alert('請先挑選公司至已選擇區域','提示');
                return false;
            }

            const url = this.$apiUrl_Quality + '/ChangeQDFMCustomer'; 
            const requestObj = {
                qdfmNo: this.tempRow.qdfmNo,
                newCustId : this.selecteds[0].vendorId, 
            }

            this.updateLoading(true);
            this.axios.post(url, requestObj).then(() => {
                this.updateLoading(false);
                // this.doQDFMSearch();
                this.qdfmQueryEvent();
                this.cancel();  //  清除
            })
            
        },

        // 主管刪除 Modal
        deleteRowModal(item) {
            const vm = this;
            this.$confirm("此操作將永久刪除該筆資料，是否繼續？", "提示", {
                confirmButtonText: "確定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                vm.deleteRow(item.qdfmNo);
            });
        },

        // 主管刪除 Api
        deleteRow(qdfmno) {            
            const vm = this;
            const url = `${this.$apiUrl_Quality}/DeleteQDFMForm/${qdfmno}`;

            this.updateLoading(true);
            this.axios.delete(url).then((response) => {
              const { status, statusMessage } = response.data;
              this.updateLoading(false);
              if (status) {
                this.$alert(statusMessage, "警告", { type: "warning" });
              } else {
                //--成功
                vm.doQDFMSearch(this.search);
              }
            });
        },

        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"]),

        vendorIdList (){
            const {hadVendorList} = this;
            const vidList =[];            
            if(hadVendorList && hadVendorList.length){
                for(let k=0;k<hadVendorList.length;k++){
                    let r = hadVendorList[k];
                    if(!vidList.includes(r.vendorId)){
                        vidList.push(r.vendorId);
                    }
                }
            }
            return vidList;
        },
        filterMemberList () {
            const v1= this.tempRow ? this.tempRow.factoryId : null;     
            const v2= this.filterValue;
            const { vendorIdList ,selecteds } = this;            
            const selectedIds = selecteds.map(function(item) {
              return item.vendorId;
            });
            return this.memberList.filter(n =>{
                if(vendorIdList && vendorIdList.includes(n.vendorId)){
                    return false;
                }
                if(selectedIds && selectedIds.includes(n.vendorId)){
                    return false;
                }


                if(v1){     //  篩選廠別
                    if(!n.vendorId.startsWith(v1)){
                        return false;
                    }
                }

                if(v2){
                    if(n.vendorAbbreviation && n.vendorAbbreviation.indexOf(v2) > -1){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return true;
                }
                
            });
        }
    },
	mounted() {
        this.getCacheQueryParam('QDFM_QueryParam', this.search);
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.search.factoryId = userFactoryId;
        }
        if(this.isMember) {
            const userInfo = this.$userInfo ;
            this.search.customerName = userInfo.companyName;  
        } else {
            this.initMemberQMList(); 
        }

        this.qdfmQueryEvent();
	},
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/select.scss';

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.table th {
    background-color: #303c50;
    color: #fff;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}


.search-item {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    &:last-child {
        margin-bottom: 0;
    }

    p {
        display: inline-block;
        margin-right: 16px;
        margin-bottom: 0;
    }

    .el-input {
    // max-width: 350px;
        flex: 1;

        ::v-deep .el-input__inner {
            height: 34px;
            line-height: 34px;
        }
    }

    .el-select {
        flex: 1;

        ::v-deep .el-input__inner {
            height: 34px;
            line-height: 34px;
        }

        ::v-deep .el-input__icon {
            line-height: 34px;
        }
    }

    .el-radio-group {
        label {
            margin-bottom: 0;
        }
    }
    
}




.btn-blue {
    color: #fff !important;
    font-size: .85em;
    background: #343b55;
    border-radius: 6px;
}

.btn-yellow {
    background: #cca836;
    color: #fff;
}

.right {
    display: block;
    text-align: right;
}


.filter-btn-wrap {
    margin-top: 24px;
}

.option {
    margin-left: .2rem;
    cursor: pointer;
}
.item_list {
    margin-bottom: 5px;
}
.item-select #left-item .item-list .item, .item-select #right-item .item-list .item {
    display: flex;
    align-items: center;
}
.item-select #left-item .item-list .item input[type=checkbox], .item-select #right-item .item-list .item input[type=checkbox] {
    display: block;
    margin-right: .5rem;
}

.filter-block .filter-btn-wrap .btn {
    line-height: auto;
}

.filter-block .filter-field .flex > .age-input, .filter-block .filter-field .flex > .year-input {
    width: 50px;
}

.white-overlay {
     background-color: rgba(0, 255, 255, 0.3);
}

.btn-gray {
    background-color: gray;
    color: white;
}

.item-select #right-item {
    padding-top: 55px;
}

.item-select #right-item .item-type {
    top: 33px;
}
</style>